module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-2fdd6a90a1c6cfa617ae79001fe3f5cc.png";